export default "https://storage.googleapis.com/prepweb-prod/dist/f17bdab0ef014c347d562be2ef49122e.svg";